export default {
  packshostSpace: (isBigPackshot: boolean, isSmall: boolean, isSlider: boolean) => {
    const paddingMap = {
      big: 0,
      small: isSlider ? [32, 32, 32, 64] : 32,
      normal: [32, 32, 64, '4.1666667vw'],
    };
    const paddingTypeForSmaller = isSmall ? 'small' : 'normal';
    const paddingType = isBigPackshot ? 'big' : paddingTypeForSmaller;
    return {
      padding: paddingMap[paddingType],
    };
  },
  imageContainer: (isError: boolean) => ({
    position: 'relative',
    pb: '100%',
    img: {
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      aspectRatio: '1 / 1',
      mixBlendMode: 'multiply',
      opacity: isError ? 0 : 1,
    },
  }),
};
